import { Typography } from '@mui/material';
import { useMemo } from 'react';
import OnboardFormLayout from '../../../components/OnboardFormLayout';

type Props = {
  message?: string | JSX.Element;
};

export const EntityIsNotSelected: React.FC<Props> = ({ message }) => {
  const content = useMemo(() => {
    if (typeof message === 'string') {
      return <Typography>{message}</Typography>;
    }

    if (typeof message === 'function') {
      return message;
    }

    return <Typography>Select row first.</Typography>;
  }, [message]);

  return (
    <OnboardFormLayout
      onSubmit={() => {
        console.log('edge case submitting form');
      }}
    >
      {content}
    </OnboardFormLayout>
  );
};
